/**
 * Iter-334 Phase A — Short share-link resolver.
 * URL: /s/:shortSlug
 * Redirects to the vendor's public page after recording the click.
 */
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function ShareLinkResolver() {
  const { shortSlug } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    axios.get(`${API}/marketplace/s/${shortSlug}`)
      .then(r => nav(r.data.redirect_to || `/vendor/${r.data.vendor_slug}?ref=share`, { replace: true }))
      .catch(() => nav('/marketplace', { replace: true }));
  }, [shortSlug, nav]);

  return <div className="min-h-[100dvh] flex items-center justify-center text-slate-500">Redirecting…</div>;
}
